import { GridCellParams, GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { standardOperators } from '../../Compounds/UpstackDataGrid/helpers';

const sfLinkRenderer = (params: GridCellParams) => {
  const linked = !!params.row?.sf_supplier_id;
  return linked ? 'Linked' : 'Unlinked';
};

export const SupplierGridColumnDefs: GridSingleSelectColDef[] = [
  {
    field: 'supplier_name',
    headerName: 'Supplier Name',
    sortable: true,
    width: 200,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'product_category',
    headerName: 'Product Category',
    sortable: true,
    width: 150,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'headquarters',
    headerName: 'Headquarters',
    sortable: true,
    width: 180,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'pricing_model',
    headerName: 'Pricing Model',
    sortable: true,
    width: 160,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'capabilities',
    headerName: 'Capabilities',
    sortable: false,
    width: 200,
    filterable: false,
    type: 'singleSelect',
    valueOptions: [],
    valueFormatter: (value: string[]) => {
      return Array.isArray(value) ? value.join(', ') : '';
    },
    description: 'Drag to move column'
  },
  {
    field: 'supported_features',
    headerName: 'Features',
    sortable: true,
    width: 120,
    filterable: false,
    type: 'singleSelect',
    valueOptions: [],
    valueFormatter: (value: string[]) => {
      return Array.isArray(value) ? `${value.length}` : '0';
    },
    description: 'Drag to move column'
  },
  {
    field: 'sf_supplier_id',
    headerName: 'SF Link',
    sortable: true,
    width: 100,
    filterable: true,
    type: 'singleSelect',
    valueOptions: ['Linked', 'Unlinked'],
    renderCell: sfLinkRenderer,
    description: 'Drag to move column'
  },
  {
    field: 'channel_manager_name',
    headerName: 'Channel Manager',
    sortable: true,
    width: 180,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'created_date',
    headerName: 'Created',
    sortable: true,
    width: 120,
    filterable: false,
    type: 'singleSelect',
    valueOptions: [],
    valueFormatter: (value: string) => {
      return value ? new Date(value).toLocaleDateString() : '';
    },
    description: 'Drag to move column'
  }
];
